import * as React from 'react';
import {lazyInject, TYPES} from '../../../utils/inversify-config';
import MeepoServiceClient from '../../../middleware/meepo-client';
import GoogleMapsIcon from 'mdi-react/GoogleMapsIcon';
import ReactTable from 'react-table';
import {Button, Card, CardBody, Col, Row} from 'reactstrap';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {isoStrToAMPM} from '../../../utils/utils';
import {localCurrency, localNumber} from '../../../utils/number-utils';
import {connect} from 'react-redux';
import Rotate3dIcon from 'mdi-react/Rotate3dIcon';
import AppAction from '../../../reduxstore/actions/action';
import {IResumenDiario} from '../../../utils/models';
import ResumenForm from './resumen-form';
import * as moment from 'moment';
import * as qs from 'query-string';

interface IState {
    header: any[];
    data: any[];
    fecha?: string;
}

interface IProps extends RouteComponentProps<any> {
    dispatch: (action: AppAction) => (any);
    resumenDiario: IResumenDiario[];
}

const mapStateToProps = (state) => {
    const stateProps = {
        resumenDiario: state.app.getResumenDiarioXRuta(),
    };
    return stateProps;
};

class ResumenDiario extends React.PureComponent<IProps, IState> {

    @lazyInject(TYPES.MEEPO_SERVICE)
    public apiClient: MeepoServiceClient;

    constructor(props) {
        super(props);
        let fecha;
        if (props.location.search) {
            fecha = qs.parse(props.location.search).fecha
        }
        this.state = {
            header: this.header,
            data: [],
            fecha
        };
    }

    private get header() {
        return [
            {
                accessor: 'ruta',
                Header: 'Ruta',
            },
            {
                accessor: 'primeraEntrega',
                Header: 'Primera Entrega',
                className: 'left-cell center',
                headerClassName: 'left-cell'
            },
            {
                accessor: 'ultimaEntrega',
                Header: 'Última Entrega',
                className: 'center',
            },
            {
                accessor: 'carteraTotal',
                Header: 'Comp. Total',
                className: 'left-cell center',
                headerClassName: 'left-cell'
            },
            {
                accessor: 'aceptados',
                Header: 'Comp. Entregados',
                className: 'center green-cell'
            },
            {
                accessor: 'rechazados',
                Header: 'Comp. Rechazados',
                className: 'center red-cell'
            },
            {
                accessor: 'parciales',
                Header: 'Comp. Parciales',
                className: 'center blue-cell'
            },
            {
                accessor: 'pendientes',
                Header: 'Comp. Pendientes',
                className: 'center grey-cell'
            },
            {
                accessor: 'efectividad',
                Header: 'Efectividad',
                className: 'left-cell center',
                headerClassName: 'left-cell'
            },
            {
                accessor: 'montoAceptado',
                Header: 'Monto por liquidar',
                className: 'center'
            },
            {
                accessor: 'montoRechazado',
                Header: 'Monto Rechazado',
                className: 'center'
            },
            {
                accessor: 'mapaAction',
                width: 80,
                className: 'center',
                sortable: false
            },
        ]
    }

    public componentWillReceiveProps(newProps) {
        this.transformarData(newProps.resumenDiario);
    }

    public componentDidMount() {
        let fecha;
        if (this.props.location.search) {
            fecha = qs.parse(this.props.location.search).fecha
            this.apiClient.cargarResumenesDiariosXRuta(fecha);
        } else {
            fecha = moment().format('YYYY-MM-DD');
        }
        this.setState({fecha});
        this.transformarData(this.props.resumenDiario);
    }

    private transformarData = (resumen: IResumenDiario[]) => {
        const content: any[] = [];
        resumen.forEach((resumen) => {
            content.push({
                ruta: resumen.ruta.descripcion,
                primeraEntrega: isoStrToAMPM(resumen.primera_entrega),
                ultimaEntrega: isoStrToAMPM(resumen.ultima_entrega),
                carteraTotal: resumen.cartera_total,
                aceptados: resumen.aceptados,
                rechazados: resumen.rechazados,
                pendientes: resumen.pendientes,
                parciales: resumen.parciales,
                efectividad: `${localNumber(resumen.efectividad * 100)} %`,
                montoAceptado: localCurrency(resumen.monto_aceptado),
                montoRechazado: localCurrency(resumen.monto_rechazado),
                mapaAction: <Button outline={true} className='icon icon--only'
                                    onClick={() => this.props.history.push(`/ruta/${resumen.ruta.id}?fecha=${this.state.fecha}`)}><GoogleMapsIcon/></Button>
            })
        });
        this.setState({data: content});
    };

    private onRefrescarClick = async (values) => {
        let fecha;
        if (values && values.fecha) {
            fecha = moment(values.fecha).format('YYYY-MM-DD');
            this.setState({fecha})
        }
        this.apiClient.cargarResumenesDiariosXRuta(fecha ? fecha : this.state.fecha);
    };

    public render() {
        return (
            <Col md={12} lg={12}>
                <Card>
                    <CardBody>
                        <div className='card__title'>
                            <h5 className='bold-text'>Resumen diario de rutas</h5>
                        </div>
                        <Row>
                            <Col md={{size: 4}}>
                                <ResumenForm
                                    defaultDate={this.state.fecha ? moment(this.state.fecha, 'YYYY-MM-DD') : null}
                                    onSubmit={this.onRefrescarClick}/>
                            </Col>
                            <Col md={{size: 1, offset: 7}} lg={{size: 1, offset: 7}} style={{textAlign: 'right'}}>
                                <Button outline={true} className='icon icon--only'
                                        onClick={this.onRefrescarClick}><Rotate3dIcon/></Button>
                            </Col>
                        </Row>
                        <ReactTable
                            className='rt-custom-table -highlight'
                            columns={this.state.header} data={this.state.data} showPagination={false}
                            resizable={false}
                            pageSize={this.state.data.length}/>
                    </CardBody>
                </Card>
            </Col>
        )
    }
}

export default withRouter(connect(mapStateToProps)(ResumenDiario) as any);



// WEBPACK FOOTER //
// ./src/components/pages/portada/resumen.tsx